import React from "react";
import ServiceDetail from "@/pages/services/ServiceDetail";

const Dishwasher = () => <ServiceDetail slug="dishwasher" />;
export default Dishwasher;
